<div
  class="chat-message-wrapper flex rounded-md p-2 mx-1 relative"
  [ngClass]="{ 'border-edit': state.mode === 'edit', highlight: state.highlight }"
  (mouseover)="setHover(true)"
  (mouseout)="setHover(false)"
>
  <y42-chat-avatar class="p-2" [avatar]="state.avatar"></y42-chat-avatar>

  <div class="flex flex-col grow overflow-hidden">
    <div class="flex justify-between">
      <span [ngClass]="{ 'truncate-name': state.showMenu }" class="truncate">
        <fa-icon
          *ngIf="state.avatar.isUnknown"
          class="text-micro cursor-pointer mr-1"
          [matTooltipPosition]="'below'"
          [matTooltip]="unknownUserTooltip"
          [icon]="['fal', 'info-circle']"
        ></fa-icon>
        <span class="font-bold">{{ state.avatar.full_name }}</span>
      </span>
      <span *ngIf="!state.showMenu" class="text-gray-700 ml-1 whitespace-nowrap">{{
        state.messageTimesStats.messageCreatedTime
      }}</span>

      <button
        *ngIf="state.showMenu"
        mat-icon-button
        class="menu-trigger"
        (mouseover)="setHover(true)"
        (mouseout)="setHover(false)"
        [matMenuTriggerFor]="controlsMenu"
        (click)="switchIsControlsMenuOpened(true)"
      >
        <fa-icon [icon]="['fal', 'ellipsis']" class="fs-13 cursor-pointer"></fa-icon>
      </button>

      <mat-menu #controlsMenu="matMenu" [xPosition]="'before'" (closed)="switchIsControlsMenuOpened(false)">
        <button mat-menu-item *ngIf="state.isEditable" (click)="startEdit()">
          <fa-icon [icon]="['fal', 'pencil']" class="pr-[8px]"></fa-icon>Edit
        </button>
        <button mat-menu-item *ngIf="state.isDeletable" (click)="deleteMessage()">
          <fa-icon [icon]="['fal', 'trash-alt']" class="pr-[8px]"></fa-icon>Delete
        </button>
      </mat-menu>
    </div>

    <quill-editor
      *ngIf="state.mode === 'view'"
      [ngModel]="state.editedContent?.text || state.message.text"
      [format]="'json'"
      [readOnly]="true"
      [bounds]="'self'"
      [theme]="'bubble'"
      [placeholder]="''"
      class="survey-text-editor w-full"
      [ngClass]="{ 'hide-toolbar-tooltip': true, 'text-gray-600': state.editedContent }"
    >
    </quill-editor>
    <!-- <div
      *ngIf="state.mode === 'view'"
      class="w-full h-full"
      [ngClass]="{ 'hide-toolbar-tooltip': true, 'text-gray-600': state.editedContent }"
      [innerHtml]="state.editedContent?.html || state.message.html"
    ></div> -->
    <span
      *ngIf="state.messageTimesStats.isUpdatedDiffFromCreated && state.mode === 'view'"
      class="text-gray-700 cursor-pointer"
      [matTooltip]="'Updated ' + state.messageTimesStats.messageUpdatedTime"
      >(edited)</span
    >

    <y42-chat-input
      *ngIf="state.mode === 'edit'"
      [avatar]="state.avatar"
      [mode]="'edit'"
      [initialComment]="state.editedContent?.text || state.message.text"
      [mentionUsers]="mentionUsers"
      (canceled)="onCanceled()"
      (commented)="onCommentChanged($event)"
    ></y42-chat-input>
  </div>
</div>
